module.exports = __webpack_public_path__ + "img/anglomama-teacher.f1f06bf9.jpg";